<template>
    <div class="dashboard__body">
        <PreLoader v-if="isLoading"/>
        <div class="header-title">{{ $t('analytics') }}</div>
        <div class="total-quantity" v-if="currentSchool.schoolId">
            <div class="total-block teachers">
                <img src="../../assets/images/vector-quantity.svg" alt="">
                <span class="text" v-html="$t('teacherQuantity')"/>
                <span class="numbers">{{ currentSchool.totalInstructors }}</span>
            </div>
            <div class="total-block students">
                <img src="../../assets/images/vector-quantity.svg" alt="">
                <span class="text" v-html="$t('studentQuantity')"/>
                <span class="numbers">{{ currentSchool.totalStudents }}</span>
            </div>
        </div>

        <div class="select-track-data">
            <div class="filter-block">
                <div class="date-picker">
                    <v-menu v-model="showPickerStart" :close-on-content-click="false" :nudge-right="40"
                            transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field outlined dense v-model="trackObj.startDate" :label="$t('from')"
                                          append-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"/>
                        </template>
                        <v-date-picker locale="ru-RU" v-model="dateStart"
                                       @input="onSelectTrackDate('showPickerStart')"/>
                    </v-menu>
                </div>
                <div class="date-picker">
                    <v-menu v-model="showPickerEnd" :close-on-content-click="false" :nudge-right="40"
                            transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field outlined dense v-model="trackObj.endDate" :label="$t('to')"
                                          append-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"/>
                        </template>
                        <v-date-picker locale="ru-RU" v-model="dateEnd" @input="onSelectTrackDate('showPickerEnd')"/>
                    </v-menu>
                </div>
            </div>
            <div class="filter-block">
                <v-select outlined dense :no-data-text="$t('no_data')" :items="roles" :item-text="getRoleName"
                          item-value="id" :label="$t('role')" :rules="required" v-model="trackObj.roleId"/>
                <v-btn color="primary" style="height: 40px; width: 50%" @click="getAnalytics">{{ $t('show') }}</v-btn>
            </div>
        </div>

<!--        <div class="role-title" v-if="currentRole">-->
<!--            <h3>{{ $t(`${currentRole}`) }}</h3>-->
<!--        </div>-->

        <v-simple-table class="dash-tab">
            <template v-slot:default>
                <thead>
                <tr>
                    <th class="text-left" style="font-weight: bold; font-size: 14px">№</th>
                    <th class="text-left" style="font-weight: bold; font-size: 14px">{{ $t('full_name') }}</th>
                    <th class="text-left" style="font-weight: bold; font-size: 14px">{{ $t('entersSystem') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(user, i) in currentSchool.active" :key="i">
                                    <td>{{ i + 1 }}</td>
                                    <td>{{ user.fullName }}</td>
                                    <td>{{ user.count }}</td>
                </tr>
                </tbody>
            </template>
        </v-simple-table>

        <div class="txt-empty" v-if="!currentSchool.active" v-html="$t('no_data')"></div>

        <!--TABLE CONTENT-->
<!--        <table class="analytics table bordered">-->
<!--            <thead>-->
<!--            <tr>-->
<!--                <th>№</th>-->
<!--                <th>{{ $t('full_name') }}</th>-->
<!--                <th>{{ $t('entersSystem') }}</th>-->
<!--            </tr>-->
<!--            </thead>-->
<!--            <tbody>-->
<!--            <tr v-for="(user, i) in currentSchool.active" :key="i">-->
<!--                <td>{{ i + 1 }}</td>-->
<!--                <td>{{ user.fullName }}</td>-->
<!--                <td>{{ user.count }}</td>-->
<!--            </tr>-->
<!--            </tbody>-->
<!--        </table>-->

<!--        <div class="empty-data" v-if="!currentSchool.active" v-html="$t('no_data')"></div>-->
    </div>
</template>

<script>
import AnalyticsService from '@/_services/analytics.service'
import moment from 'moment'
import { RoleService } from '@/_services/role.service'
import PreLoader from '@/components/preloader/PreLoader'
const roleService = new RoleService()

export default {
  name: 'SuperAdminDashboard',
  components: {
    PreLoader
  },

  data () {
    return {
      required: [v => !!v || this.$t('required')],
      trackObj: {
        startDate: '',
        endDate: moment().format('DD.MM.YYYY'),
        roleId: ''
      },
      showPickerStart: false,
      showPickerEnd: false,
      isLoading: false,
      dateStart: '',
      dateEnd: moment().format('YYYY-MM-DD'),
      currentRole: '',
      roles: [],
      currentSchool: {
        active: []
      }
    }
  },

  computed: {
    userProfile () {
      return this.$store.state.account.profile
    },
    school () {
      return this.userProfile.schools[0]
    }
  },

  created () {
    this.setPreviousMonth()
    this.fetchAllRoles()
  },

  methods: {
    setPreviousMonth () {
      const dateMonthAgo = new Date().setMonth(new Date().getMonth() - 1)
      this.trackObj.startDate = moment(dateMonthAgo).format('DD.MM.YYYY')
      this.dateStart = moment(dateMonthAgo).format('YYYY-MM-DD')
    },

    fetchAllRoles () {
      const activeRoles = ['ROLE_INSTRUCTOR', 'ROLE_STUDENT']
      roleService.listPageable().then((res) => {
        res.forEach((roleObj) => {
          if (activeRoles.includes(roleObj.code)) {
            this.roles.push(roleObj)
          }
        })
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

    onSelectTrackDate (picker) {
      this.trackObj.startDate = moment(this.dateStart, 'YYYY-MM-DD').format('DD.MM.YYYY')
      this.trackObj.endDate = moment(this.dateEnd, 'YYYY-MM-DD').format('DD.MM.YYYY')
      this[picker] = false
    },

    getRoleName (roleObj) {
      if (roleObj.code) {
        return this.$t(`${roleObj.code}`)
      }
    },

    getAnalytics () {
      if (this.dateEnd < this.dateStart) {
        this.$toast.info(this.$t('endDateControl'))
        return
      }
      if (!this.trackObj.roleId) {
        this.$toast.info(this.$t('chooseRole'))
        return
      }
      this.isLoading = true
      this.currentRole = this.roles.find((role) => role.id === this.trackObj.roleId).code
      this.currentSchool.active = null

      AnalyticsService.userTrackPage(
                    `${this.trackObj.startDate} 24:00`,
                    `${this.trackObj.endDate} 24:00`,
                    this.trackObj.roleId,
                    this.school.id
      ).then((res) => {
        if (res.length && res[0].active && res[0].active.length) {
          this.currentSchool = Object.assign({}, res[0], {
            active: res[0].active.sort((a, b) => b.count - a.count)
          })
        }
        this.isLoading = false
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    }
  }

}
</script>

<style lang="scss" scoped>
th, td{
    vertical-align: middle;
    text-align: center!important;
    border: rgba(198, 203, 212, 0.58) solid 1px;
}
td{
    padding: 10px 16px !important;
}
.filter-block{
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 8px;
}

.dash-tab{
    max-width: 770px;
    margin: 0 auto;
}

.txt-empty{
    margin: 0 auto; padding: 8px; width: max-content; font-size: 14px
}

@media screen and (max-width: 768px) {
    .header-title{
        font-size: 20px!important;
        width: 100%;
        text-align: center;
    }
    .select-track-data{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 0!important;
    }
    .filter-block{
        width: 100%;
        justify-content: space-between;
    }
    .dashboard__body{
        padding: 10px!important;
    }
}
th, tr {
    vertical-align: middle;
}
    .dashboard__body {
        padding: 10px 30px;
        .header-title {
            margin-bottom: 15px;
            font-size: 28px;
            font-weight: bold;
        }

        .total-quantity {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 35px;
            flex-wrap: wrap;
            gap: 8px;
            .total-block {
                position: relative;
                .text {
                    position: absolute;
                    white-space: nowrap;
                    right: 30px;
                    top: 50%;
                    transform: translateY(-50%);
                }
                .numbers {
                    position: absolute;
                    left: 26px;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 60px;
                    text-align: center;
                }
                &.teachers {
                    //margin-right: 20px;
                }
                &.students {
                }
                img {
                    border-radius: 10px;
                }
            }
        }

        .select-track-data {
            display: flex;
            justify-content: center;
            gap: 8px;
            .date-picker {
                max-width: 210px;
                //margin-right: 15px;
            }
            .v-select {
                max-width: 210px;
                //margin-right: 15px;
            }
            .school-select {
                display: flex;
                align-items: center;
                margin-right: 20px;
                .v-select {
                    margin-right: 5px;
                    max-width: 200px;
                }
            }
        }

        .role-title {
            text-align: center;
            h3 {
                color: #1890f0;
            }
        }

        table.analytics {
            max-width: 1024px;
            margin: 30px auto 0;
            th {
                white-space: nowrap;
            }
            th, td {
                font-weight: bold;
            }
        }

        .empty-data {
            width: 1024px;
            margin: 15px auto 0;
            text-align: center;
            font-size: 20px;
            font-weight: bold;
        }

        /*> div {*/
        /*display: flex;*/
        /*justify-content: space-evenly;*/
        /*margin: 20px 0;*/
        /*}*/
        /*> div:first-child {*/
        /*img {*/
        /*width: 20%;*/
        /*}*/
        /*}*/
        /*> div:last-child {*/
        /*> div {*/
        /*width: 44%;*/
        /*> div:first-child {*/
        /*img {*/
        /*width: 100%;*/
        /*}*/
        /*}*/
        /*div:last-child {*/
        /*display: flex;*/
        /*justify-content: space-between;*/
        /*margin-top: 10px;*/
        /*}*/
        /*img {*/
        /*width: 48%;*/
        /*}*/
        /*}*/
        /*img {*/
        /*width: 20%;*/
        /*}*/
        /*}*/
    }
</style>
